import(/* webpackMode: "eager" */ "C:\\my project\\work\\gitlab910\\website\\home\\scrm-saas-home\\node_modules\\antd\\es\\index.js");
;
import(/* webpackMode: "eager" */ "C:\\my project\\work\\gitlab910\\website\\home\\scrm-saas-home\\src\\app\\globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\my project\\work\\gitlab910\\website\\home\\scrm-saas-home\\src\\components\\common\\ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoadingProvider"] */ "C:\\my project\\work\\gitlab910\\website\\home\\scrm-saas-home\\src\\components\\common\\LoadingProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RouteProgress"] */ "C:\\my project\\work\\gitlab910\\website\\home\\scrm-saas-home\\src\\components\\common\\RouteProgress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider"] */ "C:\\my project\\work\\gitlab910\\website\\home\\scrm-saas-home\\src\\components\\common\\ToastProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "C:\\my project\\work\\gitlab910\\website\\home\\scrm-saas-home\\src\\components\\ui\\toaster.tsx");
